/* BAM Animations v1 - extracted from snippets/bam-animations.liquid 2026-08-26.
   Logic unchanged. Now loaded with defer instead of parsed inline in <head>.
   Self-contained IIFE, exports no globals. */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ===== SCROLL PROGRESS BAR ===== */
  function setupScrollProgress(){
    var bar = document.createElement('div');
    bar.className = 'bam-scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update(){
      var scrolled = window.scrollY;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (scrolled / max) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ===== SCROLL TO TOP ===== */
  function setupScrollToTop(){
    var btn = document.createElement('button');
    btn.className = 'bam-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function(){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);
    var ticking = false;
    function update(){
      if (window.scrollY > 600) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ===== MAGNETIC CTAs ===== */
  function setupMagnetic(){
    var selectors = '.bam-fs-cta, .button--primary, button.primary, .bam-sticky-atc__btn, .product__add-to-cart, .cart__checkout-button';
    document.querySelectorAll(selectors).forEach(function(btn){
      if (btn.dataset.bamMagnetic === '1') return;
      btn.setAttribute('data-bam-magnetic', '1');
      btn.addEventListener('mousemove', function(e){
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.18) + 'px, ' + (y * 0.18) + 'px)';
      });
      btn.addEventListener('mouseleave', function(){
        btn.style.transform = '';
      });
    });
  }

  /* ===== CART ICON BOUNCE ===== */
  function setupCartBounce(){
    function findCartIcon(){
      return document.querySelector('[class*="cart-icon"], a[href="/cart"], [data-cart-toggle], cart-icon, [aria-controls*="cart"]');
    }
    function bounce(){
      var icon = findCartIcon();
      if (!icon) return;
      icon.classList.remove('bam-cart-bounce');
      void icon.offsetWidth; /* restart animation */
      icon.classList.add('bam-cart-bounce');
      setTimeout(function(){ icon.classList.remove('bam-cart-bounce'); }, 700);
    }
    /* Watch for add-to-cart events */
    document.addEventListener('cart:updated', bounce);
    document.addEventListener('cart:added', bounce);
    /* Catch form submits to add-to-cart */
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') !== -1) {
        setTimeout(bounce, 400);
      }
    });
  }

  /* ===== COUNT-UP STAT NUMBERS ===== */
  function setupCountUp(){
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.bam-fs-stat__num, [data-bam-count]');
    targets.forEach(function(el){
      var raw = el.dataset.bamCount || el.textContent.trim();
      /* Skip if not numeric */
      var m = raw.match(/(\$?)(-?\d+\.?\d*)([^\d]*)/);
      if (!m) return;
      var prefix = m[1] || '';
      var target = parseFloat(m[2]);
      var suffix = m[3] || '';
      if (isNaN(target)) return;
      el.dataset.bamFinal = prefix + (target % 1 === 0 ? target : target.toFixed(1)) + suffix;
      el.textContent = prefix + '0' + suffix;
      el.dataset.bamCounting = '0';
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.dataset.bamCounted === '1') return;
        el.dataset.bamCounted = '1';
        var raw = el.dataset.bamCount || el.dataset.bamFinal || '';
        var m = raw.match(/(\$?)(-?\d+\.?\d*)([^\d]*)/);
        if (!m) return;
        var prefix = m[1] || '';
        var target = parseFloat(m[2]);
        var suffix = m[3] || '';
        var dur = 1200;
        var start = performance.now();
        function tick(now){
          var t = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          var val = target * eased;
          el.textContent = prefix + (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (t < 1) requestAnimationFrame(tick);
          else el.textContent = el.dataset.bamFinal || raw;
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    targets.forEach(function(el){ io.observe(el); });
  }

  /* ===== PAGE EXIT FADE ===== */
  function setupPageExit(){
    document.addEventListener('click', function(e){
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('#') === 0) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      try {
        var url = new URL(a.href, location.href);
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname) return;
      } catch(_) { return; }
      document.body.classList.add('bam-leaving');
    });
    /* Reset if back-forward cache restores */
    window.addEventListener('pageshow', function(e){
      if (e.persisted) document.body.classList.remove('bam-leaving');
    });
  }

  function init(){
    setupScrollProgress();
    setupScrollToTop();
    setupMagnetic();
    setupCartBounce();
    setupCountUp();
    setupPageExit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-run magnetic + count-up after section reloads */
  document.addEventListener('shopify:section:load', function(){
    setupMagnetic();
    setupCountUp();
  });
})();
